<template>
  <div id="app" @onbeforeunload="checkLeave">
    <a
      id="text-size"
      style="position: absolute; z-index: -1; font-size: 12px"
    ></a>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    const agent = navigator.userAgent.toLowerCase();
    //IE
    if (agent.indexOf("trident") > 0) {
      this.$message({
        type: "warning",
        message:
          "检测到您使用的是ie浏览器，体验较差，如果希望获得更好的体验，请使用360极速模式或谷歌浏览器。",
        duration: 0,
        showClose: true,
      });
    }
  },
  methods: {
    checkLeave(event) {
      event.returnValue = "确定离开当前页面吗？";
    },
  },
};
</script>
<style lang="scss">
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
textarea,
p,
blockquote,
th,
td,
hr,
button,
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  margin: 0;
  padding: 0;
}
html,
body {
  background: #f1f1f1;
  font-size: 12px;
  height: 100%;
  width: 100%;
  padding: 0px;
  padding-right: 0 !important;
  margin: 0px;
  font-family: "Verdana", "黑体";
  &.hide-score .row .score,
  .hide-score .row .score {
    display: none;
  }
}
p.row a,
p a {
  text-decoration: none !important;
  // border-bottom: 1px solid #000;
}

p span a{
  border-bottom: none !important;
}

p img{
  max-width: 100%;
  max-height: 100%;
}

.fill-topic{
  p a {
    position: relative;
}
}

.topic-bd.fill-cont {
  overflow: visible !important;
  .edui-default.edui-editor-toolbarbox {
    top: -32px;
    .edui-toolbar {
      overflow: visible;
      white-space: nowrap;
    }
  }
}

.c-gray {
  color: #888888;
}
.c-small {
  font-size: 12px;
}
.c-gray-999 {
  color: #999;
}
.custom-tge {
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 8px 8px 8px 0px;
  color: #fff;
  text-align: center;
  &.green {
    background: linear-gradient(to right, #42cd4e, #61e76c);
  }
  &.yellow {
    background: linear-gradient(to right, #ffaa4c, #ffca08);
  }
}

.custom-row {
  display: flex;
  // .custom-col[span]{
  //   width:#{$span}
  // }
}
.no-float:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
}

#app {
  //  font-size: 3mm;
  // font-family: 宋体,SimSun,'STSong';
  height: 100%;
  color: #333;
}

.topic-bd{
  box-sizing: border-box;
}

[v-cloak] {
  display: none;
}
.dialog {
  .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
  }
  .el-dialog__body {
    padding: 15px 10px;
  }
  .dialog-cont {
    /*height: 310px;*/
    overflow-y: auto;
    border-top: 1px solid #dcdfe6;
    /*padding: 20px 20px 0;*/
  }

  .demo-Form {
    padding-left: 10px;
    .el-form-item {
      margin-bottom: 15px;
      margin-right: 12px;
    }
    .el-form-item__error {
      padding-top: 0;
    }
    .el-form-item .el-form-item {
      margin-bottom: 0;
      margin-right: 0;
    }
    .el-form-item__label {
      padding-right: 5px;
    }
  }

  .input-pading-no {
    .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }

  .dia-name {
    width: auto;
    line-height: 40px;
  }
  .add {
    position: absolute;
    right: 0;
    top: 10%;
  }
  .lp {
    margin-left: 40px;
  }
}
.ck-editor {
  overflow: hidden !important;
  p {
    margin: 0;
  }
}
.score-box {
  position: absolute;
  display: flex;
  right: 10px;
  top: 3px;
  width: 85px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #000;
}
.score-box .s-text {
  padding: 0 3px;
  line-height: 16px;
  border-right: 1px solid #000;
}
#test-obj-group {
  position: fixed;
  left: 1000px;
  opacity: 0;

  &.obj-group {
    // margin: 20px 15px 0 15px;
    margin: 10px 10px 0 10px;
    height: 90px;
  }
  .group.verticalTop {
    display: inline-block;
    vertical-align: top;
  }
  .gro-item {
    display: inline-block;
    // width: 24px;
    // height: 18px;
    width: 20px;
    height: 15px;
    margin: 0 4px 3px 0;
    &:first-child {
      min-width: 20px;
      width: auto;
    }
  }
}
.ck.ck-editor__editable_inline > :first-child {
  margin-top: 0 !important;
}
.el-message-box__wrapper {
  z-index: 222233 !important;
}
.el-dialog__wrapper {
  z-index: 222232 !important;
}
.el-select-dropdown {
  // 下拉框选项
  z-index: 222233 !important;
}
.el-loading-mask.is-fullscreen {
  z-index: 322232 !important;
}

.el-popover {
  z-index: 332232 !important;
}
.el-select-dropdown{
  z-index: 332233 !important;
  
}

.el-table{
  width: 99.9%;
}

.el-popup-parent--hidden{
  overflow: initial !important;
}

.card-name{
.edui-default .edui-editor-toolbarbox {
  right: 0;
  opacity: .8;
}
}

// .ck-content .square_score{
//   position: relative
// }

// .ck-content .square_score::after{
//   content: '';
//   background-color: #fff;
//   border: 1px solid #333;
//   height: 30px;
//   width: 46px;
//   display: inline-block;
//   right: 0;
//   bottom: 1px;
//   position: absolute
// }

// .row span[style*="text-decoration: underline"] {
//   text-decoration: none !important;
//   border-bottom: 1px solid #000;
// }
</style>
